module.exports = {"id":"227530","name":"Damián Lemos","rating":"71","photo":"./data/images/photos/0/227530.png","club":{"name":"CA Patronato","logo":"./data/images/clubs/CAPatronato.png"},"positions":["MDC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DamianLemos0.json
// module id = 902
// module chunks = 0